import { render, staticRenderFns } from "./index.vue?vue&type=template&id=764ec6b5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=764ec6b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ec6b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764ec6b5')) {
      api.createRecord('764ec6b5', component.options)
    } else {
      api.reload('764ec6b5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=764ec6b5&scoped=true&", function () {
      api.rerender('764ec6b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/zone-config/index.vue"
export default component.exports